import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom, timeout } from 'rxjs';

import { APP_CONFIG } from '../../core/config/app-config.token';
import { HttpClientPort, HttpQuery, HttpRequest } from '../../core/http/http-client.port';
import { HttpError } from '../../core/http/http-error';

@Injectable()
export class AngularHttpClient extends HttpClientPort {
  private readonly http = inject(HttpClient);
  private readonly config = inject(APP_CONFIG).api;

  get(request: HttpRequest): Promise<unknown> {
    return this.send(this.buildUrl(request.path), this.buildParams(request.query));
  }

  getAbsolute(url: string): Promise<unknown> {
    return this.send(url, new HttpParams());
  }

  private buildUrl(path: string): string {
    return `${this.config.baseUrl}${this.config.path}${path}`;
  }

  private buildParams(query: HttpQuery | undefined): HttpParams {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(query ?? {})) {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value));
      }
    }
    return params;
  }

  private async send(url: string, params: HttpParams): Promise<unknown> {
    const response = this.http.get(url, {
      params,
      headers: { Accept: 'application/json' },
      responseType: 'json',
    });

    try {
      return await firstValueFrom(response.pipe(timeout(this.config.timeoutMs)));
    } catch (error) {
      throw this.toHttpError(url, error);
    }
  }

  private toHttpError(url: string, error: unknown): HttpError {
    if (error instanceof HttpErrorResponse) {
      return HttpError.fromStatus(url, error.status, error.message);
    }
    if (error instanceof Error && error.name === 'TimeoutError') {
      return new HttpError('timeout', url, null, `La petición superó ${this.config.timeoutMs} ms`);
    }
    return new HttpError('network', url, null, String(error));
  }
}
